import * as _ from "lodash";

const serialize = function (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  }
  return str.join("&");
};

const urlFromState = function (state, params, opts) {
  if (window["C"].APP_NAME === "retailer") {
    if (state === "layout.cart") {
      return { url: "cart", omit: [] };
    } else if (state === "layout.referrals") {
      return { url: "refer", omit: [] };
    } else if (state === "layout.storefront") {
      let distributorId = params["distributorId"] || params["distributor_id"];
      return { url: `storefront/${distributorId}`, omit: ["distributorId"] };
    } else if (state === "layout.sculpture_reports") {
      return { url: "sculpture_reports", omit: [] };
    } else if (state === "layout.reports") {
      return { url: "reports", omit: [] };
    } else if (state === "layout.reports.overview") {
      return { url: "reports", omit: [] };
    } else if (state === "layout.quick_order_list_index") {
      return { url: "lists", omit: [] };
    } else if (state === "layout.list_details") {
      let listId = params["listId"];
      return { url: `lists/${listId}`, omit: ["listId"] };
    } else if (state === "layout.limited_ordering_products") {
      return { url: "product_approvals", omit: [] };
    } else if (state === "layout.invoices") {
      return { url: "invoices", omit: [] };
    } else if (state === "layout.invoice_details") {
      let invoiceId = params["invoiceId"];
      return { url: `invoices/${invoiceId}`, omit: ["invoiceId"] };
    } else if (state === "layout.invoices_credits") {
      return { url: "invoices/credits", omit: [] };
    } else if (state === "layout.invoice_settings") {
      return { url: `invoices/settings`, omit: [] };
    } else if (state === "layout.credit_details") {
      let invoiceId = params["invoiceId"];
      return { url: `invoices/credits/${invoiceId}`, omit: ["invoiceId"] };
    } else if (state === "layout.sponsored_content") {
      let slug = params["slug"];
      return { url: `sc/${slug}`, omit: ["slug"] };
    } else if (state === "layout.product_listing") {
      return { url: "product_listing", omit: [] };
    } else if (state === "layout.home") {
      return { url: "", omit: [] };
    } else if (state === "layout.product_detail") {
      let productId = params["productId"];
      return { url: `products/${productId}`, omit: ["productId"] };
    } else if (state === "layout.deal_detail") {
      let dealId = params["dealId"];
      return { url: `deals/${dealId}`, omit: ["dealId"] };
    } else if (state === "layout.deals_v2") {
      let distributorId = params["distributorId"];
      let productGroupId = params["productGroupId"];
      return {
        url: `deals/v2/${distributorId}/${productGroupId}`,
        omit: ["distributorId", "productGroupId"],
      };
    } else if (state === "layout.sell_sheets") {
      return { url: "sellsheets", omit: [] };
    } else if (state === "layout.sell_sheet") {
      let sellSheetId = params["sellSheetId"];
      return { url: `sellsheet/${sellSheetId}`, omit: ["sellSheetId"] };
    } else if (state == "layout.settings") {
      return { url: "settings/index", omit: [] };
    } else if (state == "layout.profile") {
      return { url: "settings/profile", omit: [] };
    } else if (state == "layout.notifications") {
      return { url: "settings/notifications", omit: [] };
    } else if (state == "layout.locations") {
      return { url: "settings/locations", omit: [] };
    } else if (state == "layout.accounts") {
      return { url: "settings/accounts", omit: [] };
    } else if (state == "layout.pricing") {
      return { url: "settings/pricing/index", omit: [] };
    } else if (state == "layout.users") {
      return { url: "settings/employees/index", omit: [] };
    } else if (state == "layout.pricing_details") {
      let distributorId = params["distributorId"];
      return { url: `settings/pricing/${distributorId}`, omit: ["distributorId"] };
    } else if (state == "layout.user_details") {
      let userId = params["userId"];
      return { url: `settings/employees/${userId}`, omit: ["userId"] };
    } else if (state == "layout.messaging_center_index") {
      return { url: "messaging", omit: [] };
    } else if (state == "layout.order_success") {
      return { url: "cart/success", omit: [] };
    } else if (state == "layout.order_groups") {
      return { url: "orders", omit: [] };
    } else if (state == "layout.order_details") {
      let orderId = params["orderId"];
      return { url: `orders/${orderId}`, omit: ["orderId"] };
    } else if (state == "layout.distributors") {
      return { url: "distributors", omit: [] };
    } else if (state === "layout.apply") {
      const applicationId = params["id"];
      return { url: `apply/${applicationId}`, omit: ["id"] };
    } else if (state === "layout.apply_new") {
      return { url: "apply" };
    } else if (state === "layout.product_missing") {
      return { url: "product_missing" };
    } else if (state === "layout.distributor_credential_management") {
      return { url: "credential_management" };
    } else {
      throw new Error("Unknown state: " + state);
    }
  } else if (window["C"].APP_NAME === "supplier") {
    if (state === "layout.product_sheet") {
      let productSheetId = params["productSheetId"];
      return { url: `supplier/product_sheets/${productSheetId}`, omit: ["productSheetId"] };
    } else if (state === "layout.product_sheet_preview") {
      let productSheetId = params["productSheetId"];
      return { url: `supplier/product_sheets/preview/${productSheetId}`, omit: ["productSheetId"] };
    } else if (state === "layout.product_sheets") {
      return { url: `supplier/product_sheets`, omit: [] };
    } else if (state === "layout.home") {
      return { url: `supplier`, omit: [] };
    }
  } else if (window["C"].APP_NAME === "distributor") {
    if (state === "layout.home") {
      return { url: `distributor` };
    } else if (state === "layout.orders") {
      return { url: `distributor` };
    } else if (state === "layout.rep_confirm") {
      const token = params["token"];
      const repId = params["repId"];
      return { url: `distributor/orders/${token}/${repId}`, omit: ["token", "repId"] };
    } else if (state === "layout.rep_signup") {
      const token = params["token"];
      const repId = params["repId"];
      return { url: `distributor/sign-up/${token}/${repId}`, omit: ["token", "repId"] };
    } else if (state === "layout.order_info") {
      const orderId = params["order_id"];
      return { url: `distributor/order_info/${orderId}`, omit: ["order_id"] };
    } else if (state === "layout.profile") {
      return { url: `distributor/profile` };
    } else if (state === "layout.notifications") {
      return { url: `distributor/notifications` };
    } else if (state === "layout.vacations") {
      return { url: `distributor/vacations` };
    } else if (state === "layout.retailers") {
      return { url: `distributor/retailers` };
    } else if (state === "layout.retailer_details") {
      const retailerId = params["retailerId"];
      return { url: `distributor/retailers/${retailerId}`, omit: ["retailerId"] };
    } else if (state === "layout.sales_reps") {
      return { url: `distributor/sales_reps` };
    } else if (state === "layout.sales_rep_details") {
      const salesRepId = params["salesRepId"];
      return { url: `distributor/sales_reps/${salesRepId}`, omit: ["salesRepId"] };
    } else if (state === "layout.referrals") {
      return { url: `distributor/refer` };
    } else if (state === "layout.retailer_onboarding") {
      return { url: `distributor/retailer_onboarding` };
    } else if (state === "layout.storefronts_preview") {
      const distributorId = params["distributor_id"];
      return { url: `distributor/storefronts/preview/${distributorId}`, omit: ["distributor_id"] };
    } else if (state === "layout.storefronts_preview_content") {
      const distributorId = params["distributor_id"];
      return {
        url: `distributor/storefronts/preview_content/${distributorId}`,
        omit: ["distributor_id"],
      };
    } else if (state === "layout.storefronts") {
      return { url: `distributor/storefronts` };
    } else if (state === "layout.storefronts_show") {
      const did = params["did"];
      return { url: `distributor/storefronts/${did}`, omit: ["did"] };
    } else if (state === "layout.product_sheets") {
      return { url: `distributor/product_sheets` };
    } else if (state === "layout.product_sheet") {
      const productSheetId = params["productSheetId"];
      return { url: `distributor/product_sheets/${productSheetId}`, omit: ["productSheetId"] };
    } else if (state === "layout.product_sheet_preview") {
      const productSheetId = params["productSheetId"];
      return {
        url: `distributor/product_sheets/preview/${productSheetId}`,
        omit: ["productSheetId"],
      };
    } else if (state === "layout.payments") {
      return { url: `distributor/payments` };
    } else if (state === "layout.products") {
      return { url: `distributor/products` };
    } else if (state === "layout.product_detail") {
      let productId = params["productId"];
      return { url: `products/${productId}`, omit: ["productId"] };
    } else if (state === "layout.product_listing") {
      return { url: "product_listing", omit: [] };
    }
  }
};

export const prepUrlFromUIRouter = function (stateName, params, opts) {
  if (window["C"].APP_NAME === "demo") {
    return;
  }
  let urlRes = urlFromState(stateName, params);
  if (!urlRes) {
    console.error("MISSING MODERN ROUTE!", stateName, params);
    return "";
  }
  let url = urlRes.url;
  let toGo = "/" + url;
  let qp = serialize(_.omit(params, urlRes.omit));
  if (qp.length > 0) {
    toGo += "?" + qp;
  }
  return toGo;
};

export const modernRoutes = function (stateName) {
  if (window["C"].APP_NAME === "retailer") {
    return {
      "layout.home": "/",
      "layout.product_listing": "/product_listing",
      "layout.quick_order_list_index": "/lists",
      "layout.list_details": "/lists/:listId",
      "layout.settings": "/settings/index",
      "layout.profile": "/settings/profile",
      "layout.notifications": "/settings/notifications",
      "layout.locations": "/settings/locations",
      "layout.accounts": "/settings/accounts",
      "layout.pricing": "/settings/pricing/index",
      "layout.users": "/settings/employees/index",
      "layout.user_details": "/settings/employees/:userId",
      "layout.pricing_details": "/settings/pricing/:distributorId",
      "layout.sculpture_reports": "/sculpture_reports",
      "layout.sponsored_content": "/sc/:slug",
      "layout.messaging_center_index": "/messaging",
      "layout.rep_recommendation": "/rep_recommendations/:id",
      "layout.rep_recommendations": "/rep_recommendations",
      "layout.product_detail": "/products/:productId",
      "layout.product_missing": "/product_missing",
      "layout.reports": "/reports",
      "layout.reports.overview": "/reports",
      "layout.distributors": "/distributors",
      "layout.storefront": "/storefront/:distributor_id",
      "layout.cart": "/cart",
      "layout.order_success": "/cart/success",
      "layout.deal_detail": "/deals/:dealId",
      "layout.order_groups": "/orders",
      "layout.order_details": "/orders/:orderId",
      "layout.referrals": "/refer",
      "layout.limited_ordering_products": "/product_approvals",
      "layout.apply_new": "/apply",
      "layout.apply": "/apply/:id",
      "layout.invoices": "/invoices",
      "layout.invoice_details": "/invoices/:invoiceId",
      "layout.invoices_credits": "/invoices/credits",
      "layout.credit_details": "/invoices/credits/:invoiceId",
      "layout.invoice_settings": "/invoices/settings",
    }[stateName];
  } else if (window["C"].APP_NAME === "supplier") {
    return {
      "layout.product_sheets": "/supplier/product_sheets",
      "layout.product_sheet": "/supplier/product_sheets/:productSheetId",
      "layout.product_sheet_preview": "/supplier/product_sheets/preview/:productSheetId",
    }[stateName];
  } else if (window["C"].APP_NAME === "distributor") {
    return {
      "layout.home": "/distributor",
      "layout.orders": "/distributor",
      // "layout.rep_confirm": "/distributor/orders/:token/:repId",
      // "layout.rep_signup": "/distributor/sign-up/:token/:repId",
      // "layout.order_info": "/distributor/order_info/:order_id",
      "layout.profile": "/distributor/profile",
      "layout.notifications": "/distributor/notifications",
      // "layout.vacations": "/distributor/vacations",
      "layout.retailers": "/distributor/retailers",
      "layout.retailer_details": "/distributor/retailers/:retailerId",
      "layout.sales_reps": "/distributor/sales_reps",
      "layout.sales_rep_details": "/distributor/sales_reps/:salesRepId",
      // "layout.referrals": "/distributor/refer",
      "layout.retailer_onboarding": "/distributor/retailer_onboarding",
      "layout.storefronts_preview": "/distributor/storefronts/preview/:distributor_id",
      "layout.storefronts_preview_content":
        "/distributor/storefronts/preview_content/:distributor_id",
      "layout.storefronts": "/distributor/storefronts",
      "layout.storefronts_show": "/distributor/storefronts/:did",
      "layout.product_sheets": "/distributor/product_sheets",
      "layout.product_sheet": "/distributor/product_sheets/:productSheetId",
      "layout.product_sheet_preview": "/distributor/product_sheets/preview/:productSheetId",
      "layout.payments": "/distributor/payments",
      "layout.product_listing": "/product_listing",
      "layout.product_detail": "/products/:productId",
    }[stateName];
  }
};
